import { isString } from '@vue/shared'

export const optionProps = {
  label: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  }
}

export const optiontEmit = {
  ["update:modelValue"]: (value: string) => isString(value),
  input: (value: string) => isString(value),
  blur: (e: FocusEvent) => e instanceof FocusEvent,
  clear: () => true,
  change: (value: string) => isString(value),
}